module.exports = __webpack_public_path__ + "img/bertrand.0532ef26.jpg";